import React from 'react'
import { FaRegStar, FaStarHalf, FaStar } from "react-icons/fa";

const Rating = ({value, text, color }) => {

  return (
    <div className='rating'>
        <span>
            {(value >= 1) ? 
                (<FaStar color={color}/>) : 
                (value >= 0.5 ? 
                    <FaStarHalf color={color}/> : <FaRegStar color={color}/>) }
        </span>

        <span>
            {(value >= 2) ? 
                (<FaStar color={color}/>) : 
                (value >= 1.5 ? 
                    <FaStarHalf color={color}/> : <FaRegStar color={color}/>) }
        </span>

        <span>
            {(value >= 3) ? 
                (<FaStar color={color}/>) : 
                (value >= 2.5 ? 
                    <FaStarHalf color={color}/> : <FaRegStar color={color}/>) }
        </span>

        <span>
            {(value >= 4) ? 
                (<FaStar color={color}/>) : 
                (value >= 3.5 ? 
                    <FaStarHalf color={color}/> : <FaRegStar color={color}/>) }
        </span>

        <span>
            {(value >= 5) ? 
                (<FaStar color={color}/>) : 
                (value >= 4.5 ? 
                    <FaStarHalf color={color}/> : <FaRegStar color={color}/>) }
        </span>
        {/* <FaStar color={color}/>
        <FaStarHalf color={color}/> */}

      <span>{text && text}</span>
    </div>
  )
}

Rating.defaultProps = {
  color: '#FDCC0D',
}

export default Rating